import React from 'react';
import AliceCarousel from 'react-alice-carousel';
import 'react-alice-carousel/lib/alice-carousel.css';
import '../TabbedProjectComponent.css'; 


const Carousel = ({slides}) => {
 
  if (!slides) {
    return <div>No slide data available.</div>;
  }

  const items = [
    slides.img1 && <img key="img1" src={slides.img1} alt="Slide 1" />,
    slides.img2 && <img key="img2" src={slides.img2} alt="Slide 2" />,
    slides.img3 && <img key="img3" src={slides.img3} alt="Slide 3" />,
    slides.img4 && <img key="img4" src={slides.img4} alt="Slide 4" />,
  ];

  return (
    <div className="carousel-container">











      <AliceCarousel
        mouseTracking
        items={items}
        disableDotsControls 
        renderPrevButton={({ isDisabled }) => (
          <button
            className={`custom-carousel-button custom-carousel-button-prev ${
              isDisabled ? 'disabled' : ''
            }`}
          >
            ❮
          </button>
        )}
        renderNextButton={({ isDisabled }) => (
          <button
            className={`custom-carousel-button custom-carousel-button-next ${
              isDisabled ? 'disabled' : ''
            }`}
          >
            ❯
          </button>
        )}
      />
    </div>
  );
};

export default Carousel;
